<script setup lang="ts">
import type { DisciplineStageComment } from '../model/interfaces'

import { AppText } from '@shared/ui/typography'

import { useDisciplineCommentItem } from '../model/discipline-comment-item.hook'

defineOptions({
  name: 'DisciplineCommentItem',
})

const props = withDefaults(defineProps<{
  comment: DisciplineStageComment
  selected?: boolean
  editable?: boolean
}>(), {
  selected: false,
  editable: false,
})

const emit = defineEmits<{
  'click:edit': [DisciplineStageComment]
  'click:cancel': []
}>()

const {
  refView,
  refAgentUrl,
  refDate,
} = useDisciplineCommentItem({
  comment: computed(() => props.comment),
})
</script>

<template>
  <div :class="['discipline-comment-item', { selected }]">
    <div class="discipline-comment-item__head">
      <a
        v-if="refAgentUrl"
        class="discipline-comment-item__agent discipline-comment-item__agent--link"
        :href="refAgentUrl"
        target="_blank"
      >
        {{ refView.agentName }}
      </a>
      <span
        v-else
        class="discipline-comment-item__agent"
      >
        {{ refView.agentName }}
      </span>
      <span
        v-if="refView.isContacted"
        class="discipline-comment-item__via"
      >
        via
        <span
          v-for="channel in refView.channels"
          :key="channel"
          class="discipline-comment-item__channel"
        >
          {{ channel }}
        </span>
        <span
          v-if="refView.reach"
          :class="['discipline-comment-item__reach', { 'discipline-comment-item__reach--reached': refView.isReached }]"
        >
          {{ refView.reach }}
        </span>
      </span>
    </div>
    <AppText
      name="body1"
      class="discipline-comment-item__text"
    >
      {{ comment.comment }}
    </AppText>
    <div class="discipline-comment-item__controls">
      <AppText
        name="body2"
        color="slate-500"
      >
        {{ refDate }}
      </AppText>
      <template v-if="editable">
        <button
          v-if="selected"
          type="button"
          class="discipline-comment-item__edit"
          @click="emit('click:cancel')"
        >
          Cancel
        </button>
        <button
          v-else
          type="button"
          class="discipline-comment-item__edit"
          @click="emit('click:edit', comment)"
        >
          Edit
        </button>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineCommentItem.scss" />
